module.exports = new __parcel__URL__("caterpiller.1b6fd239.svg").toString();